import { EmptyView } from "@/components/view";
import { useTranslation } from "@/hooks";
import { Modal } from "@mantine/core";
import { IconApi } from "@tabler/icons-react";

export function WorkspaceModalEnhancementUndefined({
  opened,
  onClose,
  serviceId,
}: {
  opened: boolean;
  onClose: () => void;
  serviceId: string;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("enhancement").enhanceData || "Enhance Data"}
      centered
      size="md"
    >
      <EmptyView
        title="Service Not Found"
        description={`Enhancement service "${serviceId}" is not available. Please check that the service is properly configured.`}
        icon={IconApi}
        height="auto"
      />
    </Modal>
  );
}
